import { defineStore } from 'pinia'

import api from '@/api/mission.js'

export const useMissionStore = defineStore('mission', {
  state: () => ({
    missions: [],
    missionDetail: {},
    newMissionAvailable: false
  }),
  actions: {
    getMissions ({ queryParams, success, fail }) {
      api.getMission(queryParams)
        .then(response => {
          this.setMissions([...this.missions, ...response.body.data])
          success && success?.(response)
        })
        .catch(error => fail && fail?.(error))
    },
    setMissions (missions) {
      this.missions = missions
    },
    getMissionDetail ({ id, success, fail }) {
      api.getMissionDetail(id)
        .then(response => {
          this.missionDetail = response.body.data
          success?.(response)
        })
        .catch(error => fail?.(error))
    },
    getMissionAvailability ({ queryParams }) {
      api.getMission(queryParams)
        .then(response => {
          this.newMissionAvailable = !!response.body.data.length
        })
    }
  }
})
